import { Navigate } from "react-router-dom";
import { UserRoleService } from "./UserRoleService";
import { UserService } from "./UserService";
import { getRuntimeConfig } from "../utils/runtimeConfig";

export const AuthService = {

    logout(redirect = true, forceLogout = false, navigate) {
        //alert('@@@@-AuthService-logout');
        console.log('AuthService-logout', redirect, forceLogout);
        localStorage.removeItem('auth');
        if (forceLogout) {
            localStorage.removeItem('rememberLogin');
        }
        const rememberLogin = localStorage.getItem('rememberLogin') === 'true';

        if (!rememberLogin || forceLogout) {
            //alert('@@@@-AuthService-logout-sendBeacon');
            const domain = getRuntimeConfig('REACT_APP_BACKEND_URL');
            navigator.sendBeacon(`${domain}/portal/logout`);
        }
        if (redirect) {
            if (navigate) {
                navigate('/auth/login?force=true');
            } else {
                window.location.href = '/auth/login?force=true';
            }
            
        }
    },

    refreshToken() {
        const domain = getRuntimeConfig('REACT_APP_BACKEND_URL');
        return fetch(`${domain}/portal/refresh`,
            {
                method: 'POST',
                credentials: "include",

            }
        )
            .then((res) => {
                if (res.ok) {
                    return { success: true };
                } else {
                    return res.json()
                        .then(json => {
                            throw json;
                        });
                }
            })
            .catch(async err => {
                if (err instanceof TypeError) {
                    throw { connectionError: true };
                }
                if (err?.error === 'invalid_grant') {
                    throw { invalidUserOrPassword: true };
                } else if (err?.error === 'account_disabled') {
                    throw { accountDisabled: true };
                } else if (err?.error === 'account_temporary_disabled') {
                    throw { accountTemporaryDisabled: true, date: err?.date };
                } else {
                    throw { unknownError: true };
                }
            });
    },

    login(email, password) {

        const domain = getRuntimeConfig('REACT_APP_BACKEND_URL');
        const details = {
            //grant_type: 'password',
            username: email,
            password: password,
            //client_id: 'vend_frontend'
        };

        const formBody = [];
        Object.keys(details).forEach(fieldName => {
            const key = encodeURIComponent(fieldName);
            const value = encodeURIComponent(details[fieldName]);
            formBody.push(key + "=" + value);
        })
        const body = formBody.join("&");

        return fetch(`${domain}/portal/auth`,
            {
                method: 'POST',
                credentials: "include",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: body
            }
        )
            .then(async (res) => {
                if (res.ok) {
                    const profile = await UserService.getOwnProfile();
                    localStorage.setItem('profile', JSON.stringify(profile));
                    return { success: true };
                } else {
                    return res.json()
                        .then(json => {
                            throw json;
                        });
                }
            })
            .catch(async err => {

                if (err instanceof TypeError) {
                    // Likely a network error or CORS failure
                    throw { connectionError: true };
                }

                if (err?.error === 'invalid_grant') {
                    throw { invalidUserOrPassword: true };
                } else if (err?.error === 'account_disabled') {
                    throw { accountDisabled: true };
                } else if (err?.error === 'account_temporary_disabled') {
                    throw { accountTemporaryDisabled: true, date: err?.date };
                } else {
                    throw { unknownError: true };
                }
            });
    }
}